import Vue from "vue"

import resetMixin from "~/mixins/store/resetToInitialState"

const initialState = function () {
  return {
    display: false,
    unsaved: false,
    login_out: false,
    in_flow: false,
    track_mod: false,
    popup_is_alive: true,
    band_patch: 0,
    swap_account: {},
    draft_backup: {},
    track_backup: {},
  }
}

export const state = function () {
  return {
    ...initialState(),
    route: "",
  }
}

export const mutations = {
  SET_DRAFT_BACKUP: function (state, patch) {
    Vue.set(state, "draft_backup", { ...patch })
  },
  SET_TRACK_BACKUP: function (state, patch) {
    Vue.set(state, "track_backup", { ...patch })
  },
  SET_LOGIN_OUT: function (state) {
    state.login_out = true
  },
  SET_UNSAVED: function (state) {
    state.unsaved = true
  },
  RESET_UNSAVED: function (state) {
    state.unsaved = false
  },
  SET_IS_ALIVE: function (state, boolean) {
    state.popup_is_alive = boolean
  },
  SET_IN_FLOW: function (state, boolean) {
    state.in_flow = boolean
  },
  SET_DISPLAY: function (state, boolean) {
    state.display = boolean
  },
  SET_TRACK_MOD: function (state, boolean) {
    state.track_mod = boolean
  },
  SET_BAND_PATCH: function (state, id) {
    state.band_patch = id
  },
  SET_SWAP_ACCOUNT: function (state, data) {
    Vue.set(state, "swap_account", { ...data })
  },
  SET_ROUTE: function (state, route) {
    state.route = route
  },
  ...resetMixin.mutations,
}

export const actions = {
  RESET: async function ({ commit }) {
    commit("RESET", initialState())
  },
  SET_DISPLAY: function ({ commit }, boolean) {
    commit("SET_DISPLAY", Boolean(boolean))
  },
  SET_UNSAVED: function ({ commit }) {
    commit("SET_UNSAVED")
  },
}
